import { optionSchema } from '@/common/schemas/option.schema'
import { z } from 'zod'

export const updateFeesConfigurationsSchema = z.object({
  special_fee_application_mode: optionSchema,
});

export type UpdateFeesConfigurationsValidationSchema = z.infer<typeof updateFeesConfigurationsSchema>;
